import { AgChartTheme } from "ag-charts-community";

export const theme: AgChartTheme = {
    params: {
        foregroundColor: "#1e293b",
        backgroundColor: "#0F172A",
        accentColor: "#fff",
        chromeBackgroundColor: "#0F172A",
        chromeTextColor: "#FCFDFE",
        fontFamily: "Inter, serif",
        fontSize: 12,
        textColor: "#FCFDFE",
    },
};
